// extracted by mini-css-extract-plugin
export var label = "_hr-2";
export var slideContainer = "_hr-0";
export var slider = "_hr-1";